<template>
  <section class="d-inline">
    <v-btn 
        v-if="mode == 'create'"
        color="primary"
        small
        dark
        @click.stop="dialog = true"
    >
      Cadastrar Tipologia
    </v-btn>
    <v-btn
        v-else
        flat
        icon
        @click.stop="dialog = true"
    >
      <v-icon small>mdi-pencil</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline white--text green darken-2" primary-title>
          {{dialogTitle}} Tipologia
        </v-card-title>

        <v-card-text>
          <v-form v-model="valid">
            <v-text-field
              v-model="code"
              :rules="requiredRules"
              label="Código"
              required/>
            <v-text-field
              v-model="name"
              :rules="requiredRules"
              label="Nome"
              required/>
            <v-checkbox
              :checked="old"
              v-model="old"
              label="É uma tipologia antiga?"/>
            <v-checkbox
              v-model="selectable"
              label="É uma tipologia selecionável? "/>
            <v-select
              v-if="selectable"
              v-model="degrading_potential_id"
              :hint="'Selecione um Potential Degradador'"
              :items="degradingPotentials"
              item-text="name"
              item-value="id"
              single-line
              label="Potencial Degradador"/>
            <v-text-field
              v-model="degrading_potential_for_tax_name"
              :rules="requiredRules"
              label="Nome do Parâmetro do Potencial Degradador"
              v-if="selectable"
              required/>
            <v-text-field
              v-model="typology_size_for_tax_name"
              :rules="requiredRules"
              label="Nome do Paramêttro do Porte"
              v-if="selectable"
              required/>
          </v-form>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" flat @click="save">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>

import TypologyService from '@/services/applications/configurations/TypologyService';
import DegradingPotentialService from '@/services/applications/configurations/DegradingPotentialService';

export default {
  name: 'CreateOrUpdateTypology',
  components: {},
  props: ['typology', 'typologyId', 'mode'],
  mounted() {
    DegradingPotentialService
      .fetchDegradingPotential()
      .then((response) => {
        this.degradingPotentials = response.data;
      });
  },
  data() {
    return {
      requiredRules: [
        v => !!v || 'Campo Obrigatório',
      ],
      id: null,
      code: '',
      name: '',
      old: false,
      selectable: false,
      degrading_potential_id: null,
      degrading_potential_for_tax_name: '',
      typology_size_for_tax_name: '',
      typology_id: '',
      degradingPotentials: [],
      dialog: false,
      valid: false,
    };
  },
  methods: {
    save() {
      const vm = this;

      const payload = {
        id: this.id,
        code: this.code,
        name: this.name,
        old: this.old,
        selectable: this.selectable,
        degrading_potential_id: this.degrading_potential_id,
        degrading_potential_for_tax_name: this.degrading_potential_for_tax_name,
        typology_size_for_tax_name: this.typology_size_for_tax_name
      };

      if (this.typologyId !== '') {
        payload.typology_id = this.typologyId;
      }

      TypologyService
        .createOrUpdate(payload)
        .then((response) => {
          vm.$swal({
            title: `Tipologia ${ this.snackBarMode } com Sucesso`,
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            vm.$emit('createTypology', response.data);
            vm.dialog = false;
          });
        })
        .catch((error) => {
          vm.$swal({
            title: 'Erro',
            text: error.response.data.join('\n'),
            type: 'error',
            showConfirmButton: 'Ok',
          });
        });
    },
  },
  computed: {
    dialogTitle() {
      return this.mode === 'create' ? 'Cadastrar' : 'Editar';
    },
    snackBarMode() {
      return this.mode === 'create' ? 'criado' : 'atualizado';
    },
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        if (this.typology !== null) {
          this.id = this.typology.id;
          this.code = this.typology.code;
          this.name = this.typology.name;
          this.old = this.typology.old;
          this.selectable = this.typology.selectable;
          this.degrading_potential_id = this.typology.degrading_potential_id;
          this.degrading_potential_for_tax_name = this.typology.degrading_potential_for_tax_name;
          this.typology_size_for_tax_name = this.typology.typology_size_for_tax_name;
          this.typology_id = this.typology.typology_id;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
